/**
 * Create store system ipv6 routing-ospfv3
 *
 * @since 2018-07-23
 * @author jongsung.Lee(devp010)
 */

import {SystemApiPrefix as smApiPrefix} from 'utils'
import compareObject from '~/utils/compare'

export const plugins = [Plugin]

export const state = () => ({
  // axios api's urls
  apiUrlPath: {
    ospfConfig: `${smApiPrefix}/ipv6/ospfv3/config`, //                            config
    ospfStatus: `${smApiPrefix}/ipv6/ospfv3/config/status`, //                     status
    ospfNeighborStatus: `${smApiPrefix}/ipv6/ospfv3/config/status-neighbor`, //    status-neighbor
    ospfInterfaceStatus: `${smApiPrefix}/ipv6/ospfv3/config/status-interface`, //  status-interface
    ospfDatabaseStatus: `${smApiPrefix}/ipv6/ospfv3/config/status-database`, //    status-database
    ospfAdvance: `${smApiPrefix}/ipv6/ospfv3/config/advance`, //                   advance
    ripIfsCandis: `${smApiPrefix}/ipv6/ospfv3/config/advance/interface-candidates`, //      route_map interface candidates
    ospfAreas: `${smApiPrefix}/ipv6/ospfv3/config/areas`, //                       area           area
    ospAreasfIfsCandidates: `${smApiPrefix}/ipv6/ospfv3/config/areas/interface-candidates`, // interface candidates
    ospfIfsCandidates: `${smApiPrefix}/ipv6/ospfv3/config/interface-candidates`, // interface candidates
    ospfInterfaces: `${smApiPrefix}/ipv6/ospfv3/config/interfaces`, //             interface
    ospfApply: `${smApiPrefix}/ipv6/ospfv3/config/apply`,
    ospfCancel: `${smApiPrefix}/ipv6/ospfv3/config/cancel`
  },
  // copyData for editing.
  selectedItem: {},
  // areaType
  ospfAreaAuthType: [{id: 0, value: 'None'}, {id: 1, value: 'Text'}, {id: 2, value: 'MD5'}],
  ospfAreaType: [{id: 1, value: 'Regula'}, {id: 2, value: 'Stub'}, {id: 3, value: 'Virtual-Link'}],
  // ospf config
  ospfConfig: {
    enable: 0, //           enable required (one of 0, 1)
    router_id: '0.0.0.0' // Router ID required (string) (IPv4 Address)
  },
  ospfConfigClone: {
    enable: 0, //           enable required (one of 0, 1)
    router_id: '0.0.0.0' // Router ID required (string) (IPv4 Address)
  },
  // ospf status
  ospfStatus: {status: ''},
  ospfNeighborStatus: {status: ''}, //  neighbor
  ospfInterfaceStatus: {status: ''}, // interface
  ospfDatabaseStatus: {status: ''}, //  database
  // ospf advacne
  ospfAdvance: {
    redist_static_enable: 0, //   (OFF: 0, ON: 1)
    redist_rip_enable: 0, //      (OFF: 0, ON: 1)
    redist_bgp_enable: 0, //      (OFF: 0, ON: 1)
    rout_map_enable: 0, //        (OFF: 0, ON: 1)
    rout_map_sync_interval: 5, // (integer - default: 5 - minimum: 1 - maximum: 60)
    rout_map: [] //               id, rout_addr, rout_mask, metric, ifc_id, ifc_name, order
  },
  // rout_mask(integer - minimum: 0 - maximum: 31)
  rout_mapInfo: {id: '', rout_addr: null, rout_mask: 0, metric: 0, ifc_id: '', ifc_name: '', order: 1},
  ripIfsCandidateList: [],
  ospfArea: {
    id: 0,
    area: '', //           IPv4 type
    ospfv3_ifc_id: '', //  OSPFv3 interface id
    ospfv3_ifc_name: '' // OSPFv3 interface name
  },
  ospfAreaList: [],
  ospfAreaSelectList: [],
  ospfAreaIfsCandidateList: [],
  ospfIfsCandidateList: [],
  ospfIfTypeSelectList: [{label: 'Broadcast', value: 1}, {label: 'Point-to-Point', value: 2}],
  ospfInterface: {
    id: '',
    ifc_id: 0,
    ifc_name: '',
    priority: 1, //     (integer - default: 1 - minimum: 0 - maximum: 255)
    cost: 1, //         (integer - default: 1 - minimum: 1 - maximum: 65535)
    timer_hello: 10, // (integer - default: 10 - minimum: 1 - maximum: 65535)
    timer_dead: 40, //      (integer - default: 40 - minimum: 1 - maximum: 65535)
    timer_retransmit: 5, // (integer - default: 5 - minimum: 3 - maximum: 65535)
    timer_transmit: 5 //    (integer - default: 5 - minimum: 1 - maximum: 65535)
  },
  ospfInterfacesList: []
})

export const mutations = {
  resetSelectedItem (state) {
    state.selectedItem = {}
  },
  setSelectedItem (state, item) {
    state.selectedItem = item
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> config
  resetOspfConfig (state) {
    state.ospfConfig.enable = 0
    state.ospfConfig.router_id = '0.0.0.0'
  },
  setOspfConfig (state, item) {
    state.ospfConfig.enable = item.enable
    state.ospfConfig.router_id = item.router_id
    // clone
    state.ospfConfigClone.enable = _.cloneDeep(item.enable)
    state.ospfConfigClone.router_id = _.cloneDeep(item.router_id)
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> status
  resetOspfStatus (state) {
    state.ospfStatus.status = ''
  },
  setOspfStatus (state, item) {
    state.ospfStatus.status = item.status
  },
  resetOspfNeighborStatus (state) {
    state.ospfNeighborStatus.status = ''
  },
  setOspfNeighborStatus (state, item) {
    state.ospfNeighborStatus.status = item.status
  },
  resetOspfInterfaceStatus (state) {
    state.ospfInterfaceStatus.status = ''
  },
  setOspfInterfaceStatus (state, item) {
    state.ospfInterfaceStatus.status = item.status
  },
  resetOspfDatabaseStatus (state) {
    state.ospfDatabaseStatus.status = ''
  },
  setOspfDatabaseStatus (state, item) {
    state.ospfDatabaseStatus.status = item.status
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> advance
  resetOspfAdvance (state) {
    state.ospfAdvance.redist_static_enable = 0
    state.ospfAdvance.redist_rip_enable = 0
    state.ospfAdvance.redist_bgp_enable = 0
    state.ospfAdvance.rout_map_enable = 0
    state.ospfAdvance.rout_map_sync_interval = 5
    state.ospfAdvance.rout_map = []
  },
  setOspfAdvance (state, item) {
    state.ospfAdvance.redist_static_enable = item.redist_static_enable
    state.ospfAdvance.redist_rip_enable = item.redist_rip_enable
    state.ospfAdvance.redist_bgp_enable = item.redist_bgp_enable
    state.ospfAdvance.rout_map_enable = item.rout_map_enable
    state.ospfAdvance.rout_map_sync_interval = item.rout_map_sync_interval
    if (item.rout_map !== null && item.rout_map.length > 0) {
      for (const rmap of item.rout_map) {
        rmap.id = `${_.random(100, 10000)}_${rmap.rout_addr}`
      }
      state.ospfAdvance.rout_map = item.rout_map
    } else {
      state.ospfAdvance.rout_map = []
    }
  },
  moveUpRoutMapByOrder (state, item) {
    // change order the item
    state.ospfAdvance.rout_map.splice(item.itemIndex, 1)
    state.ospfAdvance.rout_map.splice(item.itemIndex - 1, 0, item)
    let iIdx = 0
    // reset order & itemIndex  properties
    for (const rmap of state.ospfAdvance.rout_map) {
      rmap.itemIndex = iIdx++
      rmap.order = iIdx
    }
  },
  moveDownRoutMapByOrder (state, item) {
    // change order the item
    state.ospfAdvance.rout_map.splice(item.itemIndex, 1)
    state.ospfAdvance.rout_map.splice(item.itemIndex + 1, 0, item)
    let iIdx = 0
    for (const rmap of state.ospfAdvance.rout_map) {
      rmap.itemIndex = iIdx++
      rmap.order = iIdx
    }
  },
  resetRipInterfaceCandidates (state) {
    state.ripIfsCandidateList = []
  },
  setRipInterfaceCandidates (state, data) {
    if (data !== undefined && data.length > 0) {
      for (const ifs of data) {
        state.ripIfsCandidateList.push(
          {
            label: ifs.name,
            value: ifs.id
          }
        )
      }
    }
  },
  // routmap dialog
  clearOspfRoutMapDialog (state) {
    state.rout_mapInfo.id = ''
    state.rout_mapInfo.rout_addr = null
    state.rout_mapInfo.rout_mask = 0
    state.rout_mapInfo.metric = 0
    state.rout_mapInfo.ifc_id = ''
    state.rout_mapInfo.ifc_name = ''
    state.rout_mapInfo.order = 1
  },
  setOspfRoutMapDialog (state, item) {
    state.rout_mapInfo.id = item.id
    state.rout_mapInfo.rout_addr = item.rout_addr
    state.rout_mapInfo.rout_mask = item.rout_mask
    state.rout_mapInfo.metric = item.metric
    state.rout_mapInfo.ifc_id = item.ifc_id
    state.rout_mapInfo.ifc_name = item.ifc_name
    state.rout_mapInfo.order = item.order
  },
  // routmap CRUD
  resetOspfRoutMapList (state) {
    state.ospfAdvance.rout_map = []
  },
  setOspfRoutMapList (state, data) {
    if (data !== undefined) {
      state.ospfAdvance.rout_map = data
    }
  },
  addOspfRoutMapList (state, item) {
    state.ospfAdvance.rout_map.push(item)
  },
  editOspfRoutMapList (state, item) {
    const findRslt = _.find(state.ospfAdvance.rout_map, {id: item.id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.ospfAdvance.rout_map.splice(_.findIndex(state.ospfAdvance.rout_map, state.selectedItem.item), 1, item)
    }
  },
  delOspfRoutMapList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.ospfAdvance.rout_map.splice(item.itemIndex, 1)
      }
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> area
  clearOspfArea (state) {
    state.ospfArea.id = 0
    state.ospfArea.area = null
    state.ospfArea.ospfv3_ifc_id = ''
    state.ospfArea.ospfv3_ifc_name = ''
  },
  setOspfArea (state, item) {
    state.ospfArea.id = item.id
    state.ospfArea.area = item.area
    state.ospfArea.ospfv3_ifc_id = item.ospfv3_ifc_id
    state.ospfArea.ospfv3_ifc_name = item.ospfv3_ifc_name
  },
  resetOspfAreaList (state) {
    state.ospfAreaList = []
  },
  setOspfAreaList (state, data) {
    state.ospfAreaList = data
  },
  resetOspfAreaSelectList (state) {
    state.ospfAreaSelectList = []
  },
  setOspfAreaSelectList (state, data) {
    for (const area of data) {
      state.ospfAreaSelectList.push(
        {
          label: area.area,
          value: area.id
        }
      )
    }
  },
  resetOspfAreaIfCandidates (state) {
    state.ospfAreaIfsCandidateList = []
  },
  setOspfAreaIfCandidates (state, data) {
    if (data !== undefined) {
      for (const ifs of data) {
        state.ospfAreaIfsCandidateList.push(
          {
            label: ifs.ifc_name,
            value: ifs.id
          }
        )
      }
    }
  },
  addOspfAreaList (state, item) {
    if (item !== undefined) {
      state.ospfAreaList.push(item)
    }
  },
  editOspfAreaList (state, item) {
    const findRslt = _.find(state.ospfAreaList, {id: item.id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.ospfAreaList.splice(_.findIndex(state.ospfAreaList, state.selectedItem), 1, item)
    }
  },
  delOspfAreaList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.ospfAreaList.splice(item.itemIndex, 1)
      }
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> network
  clearOspfNetwork (state) {
    state.ospfNetwork.id = 0
    state.ospfNetwork.network_addr = null
    state.ospfNetwork.network_mask = 0
    state.ospfNetwork.ospf_area_id = ''
    state.ospfNetwork.ospf_area_name = ''
  },
  setOspfNetwork (state, item) {
    state.ospfNetwork.id = item.id
    state.ospfNetwork.network_addr = item.network_addr
    state.ospfNetwork.network_mask = item.network_mask
    state.ospfNetwork.ospf_area_id = item.ospf_area_id
    state.ospfNetwork.ospf_area_name = item.ospf_area_name
  },
  resetOspfNetworkList (state) {
    state.osfpNetworkList = []
  },
  setOspfNetworkList (state, data) {
    state.ospfNetworkList = data
  },
  addOspfNetworkList (state, item) {
    if (item !== undefined) {
      state.ospfNetworkList.push(item)
    }
  },
  editOspfNetworkList (state, item) {
    const findRslt = _.find(state.ospfNetworkList, {id: item.id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.ospfNetworkList.splice(_.findIndex(state.ospfNetworkList, state.selectedItem), 1, item)
    }
  },
  delOspfNetworkList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.ospfNetworkList.splice(item.itemIndex, 1)
      }
    }
  },
  clearOspfInterface (state) {
    state.ospfInterface.id = ''
    state.ospfInterface.ifc_id = 0
    state.ospfInterface.ifc_name = ''
    state.ospfInterface.priority = 1
    state.ospfInterface.cost = 1
    state.ospfInterface.timer_hello = 10
    state.ospfInterface.timer_dead = 40
    state.ospfInterface.timer_retransmit = 5
    state.ospfInterface.timer_transmit = 5
  },
  setOspfInterface (state, item) {
    state.ospfInterface.id = item.id
    state.ospfInterface.ifc_id = item.ifc_id
    state.ospfInterface.ifc_name = item.ifc_name
    state.ospfInterface.priority = item.priority
    state.ospfInterface.cost = item.cost
    state.ospfInterface.timer_hello = item.timer_hello
    state.ospfInterface.timer_dead = item.timer_dead
    state.ospfInterface.timer_retransmit = item.timer_retransmit
    state.ospfInterface.timer_transmit = item.timer_transmit
  },
  resetOspfInterfaceCandidates (state) {
    state.ospfIfsCandidateList = []
  },
  setOspfInterfaceCandidates (state, data) {
    if (data !== undefined) {
      for (const ifs of data) {
        state.ospfIfsCandidateList.push(
          {
            label: ifs.name,
            value: ifs.id
          }
        )
      }
    }
  },
  resetOspfInterfaceList (state) {
    state.ospfInterfacesList = []
  },
  setOspfInterfaceList (state, data) {
    state.ospfInterfacesList = data
  },
  addOspfInterfaceList (state, item) {
    if (item !== undefined) {
      state.ospfInterfacesList.push(item)
    }
  },
  editOspfInterfaceList (state, item) {
    const findRslt = _.find(state.ospfInterfacesList, {id: item.id})
    if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
      state.ospfInterfacesList.splice(_.findIndex(state.ospfInterfacesList, state.selectedItem), 1, item)
    }
  },
  delOspfInterfaceList (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.ospfInterfacesList.splice(item.itemIndex, 1)
      }
    }
  }
}

export const actions = {
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> config
  async getOspfConfig ({commit, state}, loadingOpt) {
    commit('resetOspfConfig')
    const apiUrl = state.apiUrlPath['ospfConfig']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfConfig', result)
      return true
    } else {
      return false
    }
  },
  async editOspfConfig ({commit, state}, loadingOpt) {
    const apiUrl = state.apiUrlPath['ospfConfig']
    const rslt = await this.$axios.$put(apiUrl, state.ospfConfig, loadingOpt)
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('setOspfConfig', rslt.result)
      return true
    } else {
      return false
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> status
  async getOspfStatus ({commit, state}) {
    commit('resetOspfStatus')
    const apiUrl = state.apiUrlPath['ospfStatus']
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfStatus', result)
      return true
    } else {
      return false
    }
  },
  async getOspfNeighborStatus ({commit, state}) {
    commit('resetOspfNeighborStatus')
    const apiUrl = state.apiUrlPath['ospfNeighborStatus']
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfNeighborStatus', result)
      return true
    } else {
      return false
    }
  },
  async getOspfInterfaceStatus ({commit, state}) {
    commit('resetOspfInterfaceStatus')
    const apiUrl = state.apiUrlPath['ospfInterfaceStatus']
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfInterfaceStatus', result)
      return true
    } else {
      return false
    }
  },
  async getOspfDatabaseStatus ({commit, state}) {
    commit('resetOspfDatabaseStatus')
    const apiUrl = state.apiUrlPath['ospfDatabaseStatus']
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfDatabaseStatus', result)
      return true
    } else {
      return false
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> advance
  async getOspfAdvance ({commit, state}) {
    commit('resetOspfAdvance')
    const apiUrl = state.apiUrlPath['ospfAdvance']
    const {code, result} = await this.$axios.$get(apiUrl)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfAdvance', result)
      return true
    } else {
      return false
    }
  },
  async editOspfAdvance ({commit, state}) {
    const putParam = _.cloneDeep(state.ospfAdvance)
    if (putParam.rout_map !== undefined && putParam.rout_map.length > 0) {
      let iIdx = 0
      for (const rmap of putParam.rout_map) {
        delete rmap.id
        rmap.itemIndex = iIdx++
        rmap.order = iIdx
      }
    }
    const apiUrl = state.apiUrlPath['ospfAdvance']
    const {code, result} = await this.$axios.$put(apiUrl, putParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfAdvance', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  // rout_map
  async getRipInterfaceCandidates ({commit, state}) {
    commit('resetRipInterfaceCandidates')
    const {code, result} = await this.$axios.$get(state.apiUrlPath['ripIfsCandis'])
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setRipInterfaceCandidates', result)
      return true
    } else {
      return false
    }
  },
  addOspfRoutMapList ({commit, state}) {
    const addParam = _.cloneDeep(state.rout_mapInfo)
    // make id
    addParam.id = `${_.random(100, 10000)}_${addParam.rout_addr}`
    addParam.rout_mask = Number(addParam.rout_mask)
    commit('addOspfRoutMapList', addParam)
    return true
  },
  editOspfRoutMapList ({commit, state}) {
    const putParam = _.cloneDeep(state.rout_mapInfo)
    putParam.rout_mask = Number(putParam.rout_mask)
    commit('editOspfRoutMapList', putParam)
    return true
  },
  delOspfRoutMapList ({commit, state}, param) {
    commit('delOspfRoutMapList', param.itemIndexList)
    return true
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> area
  async getOspfAreaList ({commit, state}, loadingOpt) {
    commit('resetOspfAreaList')
    const apiUrl = state.apiUrlPath['ospfAreas']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfAreaList', result)
      return true
    } else {
      return false
    }
  },
  async getOspfAreaSelectList ({commit, state}, loadingOpt) {
    commit('resetOspfAreaSelectList')
    const apiUrl = state.apiUrlPath['ospfAreas']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfAreaSelectList', result)
      return true
    } else {
      return false
    }
  },
  async getOspfAreaIfCandidates ({commit, state}) {
    commit('resetOspfAreaIfCandidates')
    const {code, result} = await this.$axios.$get(state.apiUrlPath['ospAreasfIfsCandidates'])
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfAreaIfCandidates', result)
      return true
    } else {
      return false
    }
  },
  async addOspfAreaList ({commit, state}) {
    const apiUrl = state.apiUrlPath['ospfAreas']
    const addParam = _.cloneDeep(state.ospfArea)
    delete addParam.id
    const {code, result} = await this.$axios.$post(apiUrl, addParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('addOspfAreaList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async editOspfAreaList ({commit, state}) {
    const apiUrl = state.apiUrlPath['ospfAreas']
    const putParam = _.cloneDeep(state.ospfArea)
    const {code, result} = await this.$axios.$put(`${apiUrl}/${state.ospfArea.id}`, putParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('editOspfAreaList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async delOspfAreaList ({commit, state}, param) {
    // apply partialError.
    const res = {code: 'nok'}
    // multi delete
    const delParam = {items: []}
    for (const idx of param.idList) {
      delParam.items.push({id: idx.id, pokName: idx.pokName})
    }
    const apiUrl = state.apiUrlPath['ospfAreas']
    let rslt
    if (param.idList !== undefined && param.idList.length === 1) {
      rslt = await this.$axios.$delete(`${apiUrl}/${param.idList[0].id}`)
    } else {
      rslt = await this.$axios.$delete(apiUrl, {data: delParam})
    }
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('delOspfAreaList', param.itemIndexList)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      res.code = 'ok'
      return res
    } else {
      res.code = rslt.code
      res.errors = rslt.result.errors
      return res
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> interface list
  async getOspfInterfaceList ({commit, state}, loadingOpt) {
    commit('resetOspfInterfaceList')
    const apiUrl = state.apiUrlPath['ospfInterfaces']
    const {code, result} = await this.$axios.$get(apiUrl, loadingOpt)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfInterfaceList', result)
      return true
    } else {
      return false
    }
  },
  async getOspfInterfaceCandidates ({commit, state}) {
    commit('resetOspfInterfaceCandidates')
    const {code, result} = await this.$axios.$get(state.apiUrlPath['ospfIfsCandidates'])
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('setOspfInterfaceCandidates', result)
      return true
    } else {
      return false
    }
  },
  async addOspfInterfaceList ({commit, state}) {
    const apiUrl = state.apiUrlPath['ospfInterfaces']
    const addParam = _.cloneDeep(state.ospfInterface)
    delete addParam.id
    const {code, result} = await this.$axios.$post(apiUrl, addParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('addOspfInterfaceList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async editOspfInterfaceList ({commit, state}) {
    const apiUrl = state.apiUrlPath['ospfInterfaces']
    const putParam = _.cloneDeep(state.ospfInterface)
    const {code, result} = await this.$axios.$put(`${apiUrl}/${state.ospfNetwork.id}`, putParam)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      commit('editOspfInterfaceList', result)
      this.dispatch(`common/common/setIsChanged`, true)
      return true
    } else {
      return false
    }
  },
  async delOspfInterfaceList ({commit, state}, param) {
    // apply partialError.
    const res = {code: 'nok'}
    // multi delete
    const delParam = {items: []}
    for (const idx of param.idList) {
      delParam.items.push({id: idx.id, pokName: idx.pokName})
    }
    const apiUrl = state.apiUrlPath['ospfInterfaces']
    let rslt
    if (param.idList !== undefined && param.idList.length === 1) {
      // single
      rslt = await this.$axios.$delete(`${apiUrl}/${param.idList[0].id}`)
    } else {
      // multi
      rslt = await this.$axios.$delete(apiUrl, {data: delParam})
    }
    if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
      commit('delOspfInterfaceList', param.itemIndexList)
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, true)
      res.code = 'ok'
      return res
    } else {
      res.code = rslt.code
      res.errors = rslt.result.errors
      return res
    }
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> apply & cancel
  async setOspfApply ({commit, state}, loadingOpt) {
    const data = await this.$axios.$put(state.apiUrlPath['ospfApply'], null, loadingOpt)
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    } else {
      return false
    }
  },
  async setOspfCancel ({commit, state}, loadingOpt) {
    const data = await this.$axios.$put(state.apiUrlPath['ospfCancel'], null, loadingOpt)
    if (data.code !== undefined && (data.code).toLowerCase() === 'ok') {
      // commit common isChanage
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    } else {
      return false
    }
  }
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< Bgp apply & cancel
}

export const getters = {
  // ospf Config
  compareOspfv3ConfigData (state) {
    return compareObject(state.ospfConfig, state.ospfConfigClone)
  }
}

export const strict = false
